module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAdBAMAAAA5sHO0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUdwTO5kUu9gUO5jUe5kUe9kUu9lUO9gUO1jUe5jUe9kUO9jUO5kUe5kUqXkPqoAAAANdFJOUwDwEN/AeDAgoI1AULCvwD0yAAAA0UlEQVQY01XRQQqCQBQG4D/LwlbhppVgtGkp7YMuIHSBwAu06ABCFxA8QhfxEJKVUXOX5r0ZnTezePJ+hI9/BuCzqPoU8myV2ntBddv1cp+3aZAUIpg9gfNRBE0GTL8iONyB5cPtYUczP43B5k2zjB1aI6wR9QLFZAUHE6oDBxNKwQgTSsEAM0rBADPKgYU1agMDE2oDAxOqhYwmw03mSjFMqP6br5Rg0xTXNWxj0xSl/cQG1ZYpFn2QeO8RtFDec+hVXBz1+uGivPPCPJd7V/wBdy9JJl5DMiUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/delete-warning.png
// module id = 1084
// module chunks = 0